/**
 * Coupons list state in the URL: ?page=2&limit=50&search=hema&brand=APPLE&status=draft.
 * Values are validated and fall back to defaults, so a hand-edited URL can't 400.
 */

export const MAX_SEARCH_LENGTH = 100;
const MAX_BRAND_LENGTH = 100;
const STATUS_VALUES = ['all', 'active', 'draft', 'archived'];

export const DEFAULT_PARAMS = Object.freeze({ page: 1, limit: 20, search: '', brand: '', status: 'all' });

const intIn = (raw, min, max) => (raw !== null && /^\d+$/.test(raw) && +raw >= min && +raw <= max ? +raw : null);

/** @returns {{ params: { page: number, limit: number, search: string, brand: string, status: string }, invalid: string[] }} */
export function parseCouponsParams(searchParams) {
  const invalid = [];
  const pick = (key, value) => {
    if (searchParams.get(key) === null) return DEFAULT_PARAMS[key];
    if (value === null || value === '') {
      invalid.push(key);
      return DEFAULT_PARAMS[key];
    }
    return value;
  };
  const brand = (searchParams.get('brand') ?? '').trim();
  const status = searchParams.get('status');

  return {
    params: {
      page: pick('page', intIn(searchParams.get('page'), 1, Number.MAX_SAFE_INTEGER)),
      limit: pick('limit', intIn(searchParams.get('limit'), 1, 100)),
      search: pick('search', (searchParams.get('search') ?? '').trim().slice(0, MAX_SEARCH_LENGTH)),
      brand: pick('brand', brand.length <= MAX_BRAND_LENGTH ? brand : null),
      status: pick('status', STATUS_VALUES.includes(status) ? status : null),
    },
    invalid,
  };
}

/** URL query string; defaults are left out. */
export function toQueryString(params) {
  const qs = new URLSearchParams();
  for (const key of ['page', 'limit', 'search', 'brand', 'status']) {
    if (params[key] !== DEFAULT_PARAMS[key] && params[key] !== '') qs.set(key, String(params[key]));
  }
  return qs.toString();
}

/** Any change other than the page itself goes back to page 1. */
export function updateParams(current, changes) {
  const next = { ...current, ...changes };
  if (!Object.keys(changes).every((k) => k === 'page')) next.page = 'page' in changes ? changes.page : 1;
  return next;
}
